import { ChevronDown, FileCode2, FileText, FileJson, Braces, Settings2, KeyRound } from "lucide-react";
import { SECTION_IDS, FILE_NAMES, scrollToSection } from "./files";

const FILE_ICONS = {
  hero: { Icon: FileCode2, color: "#E44D26" },
  about: { Icon: FileText, color: "#519ABA" },
  experience: { Icon: FileJson, color: "#CBCB41" },
  skills: { Icon: Settings2, color: "#8DC149" },
  projects: { Icon: Braces, color: "#519ABA" },
  education: { Icon: FileText, color: "#888888" },
  contact: { Icon: KeyRound, color: "#FF5722" },
};

export const FileExplorer = ({ lang, activeSection, open }) => {
  if (!open) return null;
  const files = FILE_NAMES[lang];

  return (
    <div
      data-testid="ide-file-explorer"
      className="hidden md:flex w-56 shrink-0 flex-col bg-[var(--sidebar)] border-r border-[var(--border)] select-none overflow-y-auto"
      role="tree"
    >
      <div className="px-4 py-2.5 font-mono text-[10px] tracking-[0.2em] text-[var(--muted)]">EXPLORER</div>
      <div className="flex items-center gap-1 px-2 py-1 font-mono text-[11px] font-semibold tracking-wider text-[var(--text)]">
        <ChevronDown size={14} className="text-[var(--muted)]" /> PORTFOLIO
      </div>
      {SECTION_IDS.map((id) => {
        const { Icon, color } = FILE_ICONS[id];
        const active = activeSection === id;
        return (
          <button
            key={id}
            data-testid={`file-link-${id}`}
            role="treeitem"
            aria-selected={active}
            onClick={() => scrollToSection(id)}
            className={`flex items-center gap-2 pl-7 pr-3 py-[5px] font-mono text-[12.5px] text-left transition-colors ${
              active
                ? "bg-[var(--line-active)] text-[var(--text)]"
                : "text-[var(--muted)] hover:bg-[var(--line-hover)] hover:text-[var(--text)]"
            }`}
          >
            <Icon size={14} style={{ color }} className="shrink-0" />
            <span className="truncate">{files[id]}</span>
          </button>
        );
      })}
      <div className="flex-1" />
      <div className="px-4 py-3 font-mono text-[10px] text-[var(--muted)] border-t border-[var(--border)]">
        7 files · 0 problems
      </div>
    </div>
  );
};
